import { useCallback, useRef, useState } from 'react'
import { CheckCircle, Info, XCircle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const VARIANTS = {
  success: { bar: 'bg-green-500', Icon: CheckCircle, color: 'text-green-500' },
  error: { bar: 'bg-red-500', Icon: XCircle, color: 'text-red-500' },
  info: { bar: 'bg-brand-600', Icon: Info, color: 'text-brand-600' },
}

let counter = 0

export function useToast() {
  const [toasts, setToasts] = useState([])
  const timers = useRef({})

  const dismiss = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id))
    if (timers.current[id]) {
      clearTimeout(timers.current[id])
      delete timers.current[id]
    }
  }, [])

  const notify = useCallback(
    (message, variant = 'success') => {
      counter += 1
      const id = counter
      setToasts((prev) => [...prev, { id, message, variant }])
      timers.current[id] = setTimeout(() => dismiss(id), 4000)
    },
    [dismiss],
  )

  const ToastViewport = () => {
    const { t } = useTranslation()
    return (
    <div className="fixed bottom-6 right-6 z-[2000] flex w-[360px] max-w-[calc(100vw-2rem)] flex-col gap-2">
      {toasts.map((toast) => {
        const meta = VARIANTS[toast.variant] ?? VARIANTS.info
        const { Icon } = meta
        return (
          <div
            key={toast.id}
            role="status"
            className="relative overflow-hidden rounded-lg border border-gray-100 bg-white pl-1 shadow-[0_4px_12px_rgba(0,0,0,0.10),0_8px_32px_rgba(91,33,182,0.12)] animate-[slideInRight_.25s_ease]"
          >
            <span className={`absolute left-0 top-0 h-full w-1 ${meta.bar}`} />
            <div className="flex items-start gap-3 px-4 py-3">
              <Icon className={`mt-0.5 h-5 w-5 shrink-0 ${meta.color}`} aria-hidden />
              <p className="flex-1 text-sm text-gray-800">{toast.message}</p>
              <button
                type="button"
                onClick={() => dismiss(toast.id)}
                aria-label={t('cartesAcces.shared.toast.dismiss')}
                className="text-gray-300 transition hover:text-gray-500"
              >
                <XCircle className="h-4 w-4" />
              </button>
            </div>
          </div>
        )
      })}
    </div>
    )
  }

  return { notify, ToastViewport }
}
